import { BooleanField, Datagrid, List, TextField, usePermissions } from "react-admin";
import DisplayDateField from "@/components/DisplayDateField";
import { canEditTenantApiKeys } from "@/utils/tenant-api-keys-access";

export const TenantApiKeysList = () => {
  const { permissions } = usePermissions();
  const canEdit = canEditTenantApiKeys(permissions);

  return (
    <List sort={{ field: "createdAt", order: "DESC" }}>
      <Datagrid rowClick={canEdit ? "edit" : false}>
        <TextField source="name" label="Name" />
        <TextField source="keyPrefix" label="Key prefix" />
        <TextField source="appType" label="App type" />
        <BooleanField source="isActive" label="Active" />
        <DisplayDateField source="lastUsedAt" label="Last used" showTime />
        <DisplayDateField source="expiresAt" label="Expires" showTime />
        <DisplayDateField source="createdAt" label="Created" showTime />
      </Datagrid>
    </List>
  );
};

export default TenantApiKeysList;
